import { render, staticRenderFns } from "./NarrationButtons.vue?vue&type=template&id=63c47dc4&"
import script from "./NarrationButtons.vue?vue&type=script&lang=js&"
export * from "./NarrationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports